export const userDataSelector = state => state.user.userData;

export const currentUserDataSelector = state => state.user.currentUser;
